export default "__VITE_ASSET__CKc8JVxq__"